import { InfoButton } from "@repo/ui/Buttons/infoButton";
import { Size } from "@repo/ui/helpers/helpers";
import {
  SegmentedControl,
  type SegmentedControlOption,
} from "@repo/ui/toggleButton/segmentedControl";
import { SimpleTooltip } from "@repo/ui/tooltip/simpleTooltip";
import { TooltipTrigger } from "@repo/ui/tooltip/tooltipTrigger";
import type { FC } from "react";

export type PlaybookOpportunityView = "opportunities" | "all";

export interface PlaybookOpportunityToolbarProps {
  readonly view: PlaybookOpportunityView;
  readonly onViewChange: (view: PlaybookOpportunityView) => void;
  readonly outcomePluralNoun?: string;
}

const viewOptions: readonly SegmentedControlOption<PlaybookOpportunityView>[] =
  [
    { id: "opportunities", label: "Opportunities" },
    { id: "all", label: "All" },
  ];

export const PlaybookOpportunityToolbar: FC<PlaybookOpportunityToolbarProps> = (
  props,
) => {
  const { view, onViewChange, outcomePluralNoun } = props;
  const outcomeName = outcomePluralNoun ?? "outcomes";

  return (
    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
      <SegmentedControl
        aria-label="Playbook criteria view"
        size={Size.SMALL}
        options={viewOptions}
        value={view}
        onChange={onViewChange}
      />
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <span
          aria-hidden="true"
          className="box-content h-2 w-5 shrink-0 rounded-full border border-blue-300 bg-blue-100"
        />
        <span>Highlighted opportunities</span>
        <TooltipTrigger shouldCloseOnPress={false}>
          <InfoButton aria-label="About highlighted opportunities" />
          <SimpleTooltip>
            Highlights the criteria with the clearest room to improve, based on
            which behaviors matter most to {outcomeName}, performance compared
            with the team, and recent trends.
          </SimpleTooltip>
        </TooltipTrigger>
      </div>
    </div>
  );
};
